import { render } from "./LyricsTheKingIsComing.vue?vue&type=template&id=3600a9c8&scoped=true"
import script from "./LyricsTheKingIsComing.vue?vue&type=script&lang=js"
export * from "./LyricsTheKingIsComing.vue?vue&type=script&lang=js"

import "./LyricsTheKingIsComing.vue?vue&type=style&index=0&id=3600a9c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3600a9c8"]])

export default __exports__